export const SEND_EMAIL = false;

import Logo from '../../src/Gif/1739196168277Fusion Logo.png'
const user = JSON.parse(localStorage.getItem('user'))
export const COMPANY_LOGO = user?.company_logo || Logo
export const COMPANY_NAME = user?.company_name || 'Signwise Solutions'

export const ChatGifApiKey = 'AIzaSyBFaHxqfZL4xpwtA5WnSqXmrUvCvJ2bFzc'

// export const REST_API_END_POINT = 'http://localhost:4001/webservice/';
// export const REST_API = 'http://localhost:4001/';
// export const REST_API_IO = 'http://localhost:4001';
// export const BASE_URL = 'http://localhost:3000/';
// export const DOMAIN = 'localhost'

export const VERSION = '1.44';

export const FACILITIES = [
  { id: 0, name: "All" },
  { id: 1, name: "Arizona" },
  { id: 2, name: "Riverside" },
  { id: 3, name: "LA" },
  { id: 4, name: "NCA" },
  { id: 5, name: "LV" },
  { id: 6, name: "DEN" },
  { id: 7, name: "COS" },
  { id: 8, name: "OK" }
]


/** Ticket ID prefix by installation: ALL = All, AZ = Arizona, RIV = Riverside, LA = LA, NCA = NCA */
export const TICKET_PREFIX_BY_INSTALLATION = {
  0: 'ALL',
  null: 'ALL',
  undefined: 'ALL',
  1: 'AZ',
  2: 'RIV',
  3: 'LA',
  4: 'NCA',
  5: 'LV',
  6: 'DEN',
  7: 'COS',
  8: 'OK'
};
export function getTicketIdPrefix(installationId) {
  if (installationId == null) return 'ALL';
  return TICKET_PREFIX_BY_INSTALLATION[Number(installationId)] ?? 'ALL';
}
export function formatTicketId(id, installationId) {
  const prefix = getTicketIdPrefix(installationId);
  return `${prefix}-${id}`;
}

export const BASE_URL = "https://support.signwise3s.com/"
export const REST_API_END_POINT = "https://support.signwise3s.com/backend/webservice/";
export const REST_API = "https://support.signwise3s.com/backend/";
export const REST_API_IO = "https://socket-support.signwise3s.com";
export const DOMAIN = 'support';

//For messenger chat
export const STATUS_OPTIONS = [
  { id: 1, statusData: 'online', label: 'Available' },
  { id: 2, statusData: 'away', label: 'Away' },
  { id: 3, statusData: 'busy', label: 'Busy' },
  { id: 4, statusData: 'invisible', label: 'Invisible' },
  { id: 5, statusData: 'dnd', label: 'Do not disturb' },
];